
<div *ngIf="!procesando && totalPaginas>1" class="paginacion-controles">
  <button 
    (click)="cambiarPagina(-1)" 
    [disabled]="paginaActual === 1">
    &laquo; Anterior
  </button>
  
  <span>Página {{ paginaActual }} de {{ totalPaginas }}</span>

  <button 
    (click)="cambiarPagina(1)" 
    [disabled]="paginaActual === totalPaginas">
    Siguiente &raquo;
  </button>
  <div class="ir-a-pagina">
    <input 
      type="number" 
      min="1" 
      [max]="totalPaginas" 
      [(ngModel)]="paginaDeseada" 
      placeholder="Nº"
      (keyup.enter)="irAPagina()"
    >
    <button (click)="irAPagina()">Ir</button>
  </div>
</div>
<div *ngIf="!procesando" class="table-wrapper" [style]="totalPaginas>1? 'height: 80%;':'height: 85%;'" >
    <table class="table table-striped" 
        *ngIf="info?.length">
        <thead>
            <tr>
                <th *ngFor="let h of header">
                    {{ h }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of info">
                <td *ngFor="let cell of row">
                    {{ cell }}
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="procesando">
    {{ procesandoStatus }}
</div>